// Utils/Assets/SVGs/BrandMark.js
import React from "react";

const CompanyLogo = (props) => (
 <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 204 175"
            {...props}
          >
            <path
              fill="var(--blue)"
              d="M89.37,29.28a19,19,0,0,1,12.19-3.83q7.22,0,14.44-.07,9.59,7,19.42,13.66c.2,3.57.45,7.13.72,10.69-2.35.21-5,.47-7,.69-2.72.28-6.51.75-9.18,1.13,6.55,1,13.6,1.6,20.2,2.17.47-5.86.89-13.3,1.2-19.16-7.51-5.41-13.47-9.66-20.37-15.07,0-2.82.12-7.61.12-7.61,0-2,.19-4.44-.72-6.3A9.4,9.4,0,0,0,110.86.06c-1.5,0-5.67,0-7.21,0A43.14,43.14,0,0,0,65.44,19c-.46.76-1.61,2.62-2,3.37s-1.33,2.74-1.7,3.55a42,42,0,0,0-2.94,20.46C60.92,67,79.64,83.43,100.49,81.61c-26-2.11-43.3-28.67-32.29-52.82A36.67,36.67,0,0,1,94.78,8.56c4.29-.79,9.31-.55,13.68-.61H112a1,1,0,0,1,.3,0,1.34,1.34,0,0,1,1.05,1.17c0,1.19.08,5.21.12,8.42l-6.71,0c-3.73,0-7.48-.2-11.21.57C78.43,21.76,70.23,42,81,55.86a21.24,21.24,0,0,0,19.52,8.25C83.1,61.71,75.35,40.64,89.37,29.28Z"
            />
            <path
              fill="var(--blue)"
              d="M146.72,102.1c-1.25,19.86-17,34.89-36.44,37.55,16,2.24,32.22-7,39.54-21.24.37-.69.71-1.39,1-2.1a39,39,0,0,1-4.53,23.93c-.2.34-.66,1.24-.85,1.57l-2,3c-.7.85-1.58,1.94-2.27,2.8l-2.52,2.6-1.38,1.19a50.89,50.89,0,0,1-4.36,3.35c-.78.45-1.89,1.1-2.66,1.57a8.8,8.8,0,0,1-1.09.59,44.8,44.8,0,0,1-9.43,3.54,20.34,20.34,0,0,1-2.51.56l-2.56.48A37.87,37.87,0,0,0,138,156.9a26.69,26.69,0,0,0,2.34-1.44c.65-.45,1.69-1.05,2.28-1.57s2.54-2,3.18-2.67c.9-.92,2.11-2,2.91-3A41.64,41.64,0,0,0,159,122.52c.91-13.44-5.39-22.69-11.39-33.94Z"
            />
            <path
              fill="var(--blue)"
              d="M119.35,109.94l.61-.81c1.73-2.29,3.41-4.63,5-7-2,1.34-3.94,2.76-5.86,4.21a52,52,0,0,1-6.91-8.67c13.79-22,41.25-27.86,64-15.71-9.06-10.66-24.72-15-38.37-12.09a44.06,44.06,0,0,0-32.5,28.3,41.29,41.29,0,0,0,12.78,11.15Z"
            />
          </svg>
    
);

export default CompanyLogo;
